export default __webpack_public_path__ + "static/media/team.375bc502.svg";